import React, { useCallback } from "react";

import { Link } from "react-router-dom";
import { useLocation, useNavigate } from "react-router-dom-v5-compat";

interface HouseholdNameLinkProps {
  householdId: string;
  householdName: string;
}

const HouseholdNameLink: React.FC<HouseholdNameLinkProps> = ({
  householdId,
  householdName,
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  // TODO: Remove after react-router-dom upgrade
  const handleClick = useCallback(
    (e: React.MouseEvent) => {
      e.stopPropagation();
      e.preventDefault();
      navigate({
        ...location,
        pathname: `/Advisor/Households/${householdId}/Profile`,
      });
    },
    [navigate, householdId, location]
  );

  return (
    <Link to={`/Advisor/Households/${householdId}`} onClick={handleClick}>
      <div
        onClick={handleClick}
        title={`View household details for ${householdName}`}
      >
        {householdName}
      </div>
    </Link>
  );
};

export default HouseholdNameLink;
